export default "__VITE_ASSET__DKUqoO_O__"